<template>
  <div class="col-12 pg-login">
    <div class="form-login col-12 row col-md-4 px-0">
      <form class="mb-1" @submit.prevent="resetePassword">
        <div class="col-12 d-flex justify-content-center my-4">
          <img alt="Akdemica logo" class="w-50" src="../../assets/img/logo-completa.png">
        </div>

        <div class="col-12 mt-2">
          <label><small>Qual o seu Email?</small></label>
          <input
            v-model="form.email"
            class="form-control"
            type="email"
            :class="{ 'is-invalid': form.errors.has('email') }"
          />
          <has-error :form="form" field="email"></has-error>
        </div>

        <div class="col-12 mt-2">
          <button class="btn btn-success form-control"><b>Confirmar</b></button>
        </div>
      </form>

    </div>
  </div>
</template>

<script>
import Form from 'vform'
import Swal from 'sweetalert2'

export default {
  data () {
    return {
      form: new Form({
        password: undefined,
        password_confirmation: undefined,
      }),
    }
  },
  methods: {
    resetePassword: function () {
      this.form.post('/auth/reset')
        .then( () => {
          Swal.fire({
            icon: 'success',
            title: 'Sucesso',
            text: 'Se este email estiver cadastrado, você recebera um email, clique no link para alterar a sua senha.',
            time: 2000
          })
            .then( () => {
              window.location.href = '/login'
            })
        })
        .catch ( err => {
          Swal.fire({
            icon: 'error',
            title: 'Opss',
            text: 'Algo deu errado, tente novamente mais tarde',
            time: 2000
          })
          console.error('erro', err)
          this.form.errors.set('password', err.response.data.error)
        })
    }
  },
  mounted () {
    if ( this.$route.query.cid && this.$route.query.cid.length ===  36 ) {
      this.loginSocial( this.$route.query )
    }
  }
}
</script>
